import { TSortableColumn } from '../Components/GenericTable/types';

export const candidatesTableColumn: TSortableColumn[] = [
  {
    id: 'id',
    label: 'ID',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'lastname',
    label: 'Last Name',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'firstname',
    label: 'First Name',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'email',
    label: 'Email Address',
    sortable: false,
    canToggle: false,
    enabled: true
  },
  {
    id: 'matching_percent',
    label: 'Matching Percent',
    sortable: false,
    canToggle: false,
    enabled: true
  }
];
